import { render, staticRenderFns } from "./Otp1.vue?vue&type=template&id=a8b3f0fc"
import script from "./Otp1.vue?vue&type=script&lang=js"
export * from "./Otp1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports